import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { type ReactNode } from 'react';

import { type UserOptionType } from '@/api/user';
import { withFieldGroup } from '@/components/Form';
import { FieldLabel } from '@/components/Form/fields';
import { maxObjectLongNameLength } from '@/constants/numbers';
import { UserMultiSelect } from '@/features/inputs';

type NotificationSubscriptionCommonFieldsProps = {
  nameLabel?: ReactNode;
  nameInputId: string;
  recipientsInputId: string;
  isSubmitting?: boolean;
};

const NotificationSubscriptionCommonFields = withFieldGroup({
  defaultValues: {
    name: '',
    recipients: [] as UserOptionType[],
  },
  props: {
    nameLabel: undefined,
    nameInputId: '',
    recipientsInputId: '',
    isSubmitting: false,
  } as NotificationSubscriptionCommonFieldsProps,
  render: function Render({
    group,
    nameInputId,
    recipientsInputId,
    nameLabel,
    isSubmitting = false,
  }) {
    return (
      <>
        <group.AppField name="name">
          {(field) => (
            <field.Field className="col-span-full">
              <FieldLabel htmlFor={nameInputId}>
                {nameLabel ?? <Trans>Report Name</Trans>}
              </FieldLabel>
              <field.TextInput
                id={nameInputId}
                placeholder={t`Name`}
                maxLength={maxObjectLongNameLength}
              />
              <field.Error />
            </field.Field>
          )}
        </group.AppField>
        <group.AppField name="recipients">
          {(field) => (
            <field.Field className="col-span-full">
              <FieldLabel htmlFor={recipientsInputId}>
                <Trans>Recipients</Trans>
              </FieldLabel>
              <UserMultiSelect
                id={recipientsInputId}
                placeholder={t`Choose Recipients`}
                disableOwner
                disabled={isSubmitting}
                value={field.state.value}
                onChange={(nextValue) => {
                  field.handleChange((nextValue as UserOptionType[] | null) ?? []);
                  field.handleBlur();
                }}
              />
              <field.Error />
            </field.Field>
          )}
        </group.AppField>
      </>
    );
  },
});

export default NotificationSubscriptionCommonFields;
